import { AnimationFeature } from "./animation";
import { ExitAnimationFeature } from "./animation/exit";
export const animations = {
    animation: {
        Feature: AnimationFeature,
    },
    exit: {
        Feature: ExitAnimationFeature,
    },
};
//# sourceMappingURL=animations.js.map